export enum CourseType {
  Open = 0,
  Closed = 1,
}

export enum CourseTypeDic {
  open = 0,
  requiresRequest = 1,
  synchronous = 2,
}

export enum ChildFilterTypes {
  ExternalCourse = 'ExternalCourse',
  Course = 'Course',
  Participant = 'Participant',
  Area = 'Area',
  UsersAllCourse = 'UsersAllCourse',
  LearningPath = 'LearningPath',
}

export enum CourseTypeCard {
  explore = 'explore',
  pending = 'pending',
  review = 'review',
  start = 'start',
  continue = 'continue',
}
